import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function Document(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path d="M9.6 2.4H2.4A2.397 2.397 0 0 0 .012 4.8L0 19.2c0 1.32 1.08 2.4 2.4 2.4h19.2c1.32 0 2.4-1.08 2.4-2.4v-12c0-1.32-1.08-2.4-2.4-2.4H12L9.6 2.4Z" />
    </IconWrapper>
  );
}
